import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadMoreService {
  readonly itemCountMap = new Map<string, number>();

  setItemCount(url: string, count: number): void {
    this.itemCountMap.set(url, count);
  }

  getItemCount(url: string, defaultCount: number): number {
    return this.itemCountMap.get(url) ?? defaultCount;
  }

  clearItemCount(): void {
    this.itemCountMap.clear();
  }
}
